define(['angular', 'moment'], function(angular, moment) {


    /**
     * @class filtersService used to manage filters functions, constants and store current used filters
     */
    function FiltersService(orderTypeService, scenarioTypeService) {
        var self = this;

        var currentFilters = [];
        self.saved = false;

        // Possible values for params associated to filter with multiple closed choice value
        var PARAMS_VALUES = {
            status: [0, 1, 2],
            offerType: ['materialTill', 'webTill'],
            cancelled: [1, 0], // Inverted values to match this UI filter logic
            lost: [0, 1],
            abandoned: [0,1],
            cpiNotCreated: [1],
            cpiReleased: [0, 1],
            jdsInjected: [0, 1],
            cmdeKey: [0, 1],
            orderScenario: [],
            laddition: [0, 1],
            isExportJdsTrad: [0, 1],
            network: []
        };

        self.initFiltersValues = function initFiltersValues() {
            orderTypeService.getOrderTypesCodes().then(function(orderTypesCodes) {
                PARAMS_VALUES.network = orderTypesCodes;
            });
            scenarioTypeService.getScenarioTypesCodes().then(function(scenarioTypesCodes) {
                PARAMS_VALUES.orderScenario = scenarioTypesCodes;
            });
        };

        // name of filters to save
        self.filtersList = [
            'marketFilter',
            'statusFilter',
            'networkFilter',
            'cancelledFilter',
            'lostFilter',
            'abandonedFilter',
            'cpiNotCreatedFilter',
            'cpiReleasedFilter',
            'jdsInjectedFilter',
            'cmdeKeyFilter',
            'orderScenarioFilter',
            'ladditionFilter',
            'clientFilter',
            'identifiantFilter',
            'businessFilter',
            'dateStartFilter',
            'dateEndFilter',
            'creationDateStartFilter',
            'creationDateEndFilter',
            'signatureMonthFilter',
            'installationMonthFilter',
            'offerTypeFilter',
            'isExportJdsTrad'
        ];

        // Default filters based on their type
        self.getDefaultFilter = function getDefaultFilter(type, length) {
            switch (type) {
                case 'boolean':
                    return Array.apply(null, Array(length)).map(function() {
                        return false;
                    });
                    break;
                case 'integer':
                    return null;
                    break;
                case 'string':
                    return null;
                    break;
                case 'date':
                    return null;
                    break;
                case 'dateInterval':
                    return Array.apply(null, Array(length)).map(function() {
                        return null;
                    });
                    break;
                default:
                    console.error('Error on init default filter');
                    break;
            }
        };

        // Filters options
        self.dateUpdatedOptions = {
            showWeeks: false,
            startingDay: 1, // Monday
            maxMode: 'month',
            maxDate: new Date()
        };

        self.signatureMonthOptions = {
            showWeeks: false,
            minMode: 'month',
            maxMode: 'year',
            maxDate: new Date()
        };

        self.installationMonthOptions = {
            showWeeks: false,
            minMode: 'month',
            maxMode: 'year'
        };

        /**
         * Save current filters used on the orders
         * @param  {Array} filters filters sent
         * @return
         */
        self.saveFilters = function saveFilters(filters) {
            currentFilters = filters;
            self.saved = true;
            return;
        };

        /**
         * @return {Object} current filters object
         */
        self.getFilters = function getFilters() {
            return currentFilters;
        };

        /**
         * Reset current stored filters
         */
        self.clearFilters = function clearFilters() {
            currentFilters = [];
            self.saved = false;
            return;
        };

        /**
         * get a filter value from a UI filter array
         * @return {value}
         * @param filter
         * @param paramName
         */
        self.applyFilter = function applyFilter(filter, paramName) {
            return filter.indexOf(true) !== -1 ? PARAMS_VALUES[paramName][filter.indexOf(true)] : null;
        };

        /**
         * Returns list of references values with truth index in the filter
         * @param  {Array} filter filter to apply
         * @param  {Array} values list of reference values
         * @return {Array}
         */
        self.applyMultipleFilterValues = function applyMultipleFilterValues(filter, values) {
            if (typeof values === 'string') {
                values = PARAMS_VALUES[values];
            }
            return values.filter(function(value, index) {
                // filter using index of filters Array
                return filter[index];
            });
        };

        /**
         * Format Date value according to a filter
         * @param  {Date} dateFilter filter date from the UI
         * @return {String} Formatted string YYYY-MM-DD
         */
        self.applyFullDateFilter = function applyFullDateFilter(dateFilter) {
            return dateFilter ? moment(dateFilter).format('YYYY-MM-DD') : null;
        };

        /**
         * Format Date value according to a filter
         * @param  {Date} dateFilter filter date from the UI
         * @return {String} Formatted string YYYY-MM
         */
        self.applyMonthDateFilter = function applyMonthDateFilter(dateFilter) {
            return dateFilter ? moment(dateFilter).format('YYYY-MM') : null;
        };

        /**
         * Get JDS parameters according to defaut values and saved filters for the currents orders list.
         * @param {Object} filters values (sent from listCtrl)
         * @return {Object} jdsFilters object with every filter with its param value for the query
         */
        self.getJdsFilters = function getJdsFilters(filters) {
            // filters values from parameters + limit and offset values
            var jdsFilters = filters;
            // jdsFilters.limit = 200; // limit to 200 orders for the export
            jdsFilters.offset = 0;

            return jdsFilters;
        };

        self.toggle = function toggle(isOpen) {
            return !isOpen;
        };

        return self;
    }

    FiltersService.$inject = ['orderTypeService', 'scenarioTypeService'];

    angular.module('app.bdc.list.filtersService', []).factory('filtersService', FiltersService);
});
